/** Tipos da atividade */
export interface AtividadeTipo {
    id: number;
    nome: string;
    icon: string;
    motivoConclusaoBloqueada?: string;
}

export const tipoEntrarEmContato: AtividadeTipo = {id: 1, nome: 'Contato', icon: 'fas fa-phone-volume'};
export const tipoVisitar: AtividadeTipo = {id: 2, nome: 'Visita', icon: 'fas fa-street-view'};
export const tipoTarefa: AtividadeTipo = {id: 3, nome: 'Tarefa', icon: 'fas fa-bolt'};
export const tipoClienteNovo: AtividadeTipo = {id: 4, nome: 'Cliente Novo', icon: 'far fa-grin'};
export const tipoClientePreInativo: AtividadeTipo = {id: 5, nome: 'Cliente Pré-Inativo', icon: 'far fa-surprise'};
export const tipoClienteInativo: AtividadeTipo = {id: 6, nome: 'Cliente Inativo', icon: 'far fa-frown'};
export const tipoClienteRevisao: AtividadeTipo = {id: 7, nome: 'Cliente Revisão', icon: 'far fa-clipboard', motivoConclusaoBloqueada: 'Realize e confirme a revisão do cliente para concluir esta atividade'};
export const tipoClienteTituloVencido: AtividadeTipo = {id: 8, nome: 'Título Vencido', icon: 'fas fa-exclamation-triangle'};

export const atividadeTipos: AtividadeTipo[] = [
    tipoEntrarEmContato,
    tipoVisitar,
    tipoTarefa,
    tipoClienteNovo,
    tipoClientePreInativo,
    tipoClienteInativo,
    tipoClienteRevisao,
    tipoClienteTituloVencido
];

/** Tipos de atividades disponíveis para lançamento manual pelo usuário */
export const atividadesTiposLancamentoManual: AtividadeTipo[] = [
    tipoEntrarEmContato,
    tipoVisitar,
    tipoTarefa
];


/** Verifica se o tipo da atividade é entrar em contato */
export function isTipoEntrarEmContato(id: number): boolean {
    return id === tipoEntrarEmContato.id;
}

/** Verifica se o tipo da atividade é visitar */
export function isTipoVisitar(id: number): boolean {
    return id === tipoVisitar.id;
}

/** Verifica se o tipo da atividade é tarefa */
export function isTipoTarefa(id: number): boolean {
    return id === tipoTarefa.id;
}

/** Verifica se o tipo da atividade é cliente novo */
export function isTipoClienteNovo(id: number): boolean {
    return id === tipoClienteNovo.id;
}

/** Verifica se o tipo da atividade é cliente pré-inativo */
export function isTipoClientePreInativo(id: number): boolean {
    return id === tipoClientePreInativo.id;
}

/** Verifica se o tipo da atividade é cliente inativo */
export function isTipoClienteInativo(id: number): boolean {
    return id === tipoClienteInativo.id;
}

/** Verifica se o tipo da atividade é cliente revisão */
export function isTipoClienteRevisao(id: number): boolean {
    return id === tipoClienteRevisao.id;
}

/** Verifica se o tipo da atividade é cliente título vencido */
export function isTipoClienteTituloVencido(id: number): boolean {
    return id === tipoClienteTituloVencido.id;
}
